import type { Session as NextAuthSession } from 'next-auth';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { mountAuthHeaders } from '~/shared/auth/mountAuthHeaders';
import { genomeApi } from '~/shared/services/api';
import { FilteredEmployeeWithPagination } from '~/shared/types/Employee';

export const GET_FILTERED_EMPLOYEE_QUERY_KEY = 'useGetFilteredEmployee';

export type GetFilteredEmployeeAPIResponse = FilteredEmployeeWithPagination;

export async function getFilteredEmployeeData(
  searchQuery: string,
  page = 0,
  limit = 10,
  session?: NextAuthSession | null
) {
  const response = await genomeApi.get<GetFilteredEmployeeAPIResponse>(
    `/employee`,
    {
      params: {
        employeesNameOrId: searchQuery,
        offset: page,
        limit,
        orderField: 'firstName',
        orderValue: 'ASC',
      },
      headers: mountAuthHeaders(session),
    }
  );

  return response.data;
}

export function useGetFilteredEmployee<T = GetFilteredEmployeeAPIResponse>(
  searchQuery: string,
  queryOptions?: UseQueryOptions<
    GetFilteredEmployeeAPIResponse,
    unknown,
    T,
    string[]
  >
) {
  return useQuery({
    queryKey: [GET_FILTERED_EMPLOYEE_QUERY_KEY, searchQuery],
    queryFn: () => getFilteredEmployeeData(searchQuery),
    ...queryOptions,
  });
}
